'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'bomb';
var width = 512;
var height = 512;
var aliases = [128163];
var unicode = 'f1e2';
var svgPathData = 'M432 0L405.3 53.3 352 80l53.3 26.7L432 160l26.7-53.3L512 80 458.7 53.3 432 0zM326.6 105.4L304 82.7l-22.6 22.6-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9L429.3 208l-22.6-22.6-80-80zM200 192c-57.4 0-104 46.6-104 104l0 8-32 0 0-8c0-75.1 60.9-136 136-136l8 0 0 32-8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBomb = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;